import { Component } from '@angular/core';
import { ErrorPageComponent } from 'libs/shared/src/lib/page/error/error.component';

@Component({ standalone: false, selector: 'app-page-message', templateUrl: './message.component.html' })
export class CustomErrorPageComponent extends ErrorPageComponent {}
